import faInit from './fa-init';
import headerInit from './site-header';
import uiComponentsInit from './ui-components-init';
import initAllMaps from './map';
import wpcf7Init from './wpcf7-init';
export default function afterDOMLoad() {
  uiComponentsInit();
  wpcf7Init();
  faInit();
  headerInit();
  $('.ds-critical-css').remove();
  // Remplacer les images en basse def(placeholders) par les vraies images
  if (typeof DSObserve === 'function') {
    DSObserve();
  }
  initAllMaps();
  if (typeof fxMachine === 'function') {
    fxMachine();
  }
  // eslint-disable-next-line no-console
  console.log('_JS_READY');
}
